import React from 'react';
import { createStyleSheet } from '../../../utils';
import { useStyleSheet } from '../../../hooks';
import { View } from '../../View';
import { Text } from '../../Text';
import { IconButton } from '../../IconButton';
import { useTextInputContext } from '..';
export const Suggestion = ({ title, value, onDismiss }) => {
    const styles = useStyleSheet(getStyles);
    const { editor } = useTextInputContext();
    return (React.createElement(View, { style: styles.container },
        React.createElement(View, { style: styles.header },
            React.createElement(Text, { type: 'body', weight: 'semibold', size: 'md', style: styles.title }, title),
            React.createElement(View, { style: styles.actions },
                React.createElement(IconButton, { value: 'thumbs-down', onPress: () => {
                        if (onDismiss)
                            onDismiss();
                    }, type: 'secondary', accent: 'default', size: 'sm' }),
                React.createElement(IconButton, { value: 'thumbs-up', onPress: () => {
                        editor === null || editor === void 0 ? void 0 : editor.insertText(0, value);
                    }, type: 'secondary', accent: 'default', size: 'sm', style: styles.thumbsUp }))),
        React.createElement(View, { style: styles.main },
            React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', numberOfLines: 2 }, value))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        borderRadius: size.G,
        padding: size.G,
        backgroundColor: color.invert2.p4,
        borderWidth: size.A,
        borderColor: color.invert2.p4,
        marginBottom: size.C
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: size.C
    },
    title: {
        color: color.invert2.p56
    },
    main: {
        height: size.I * 2
    },
    actions: {
        flexDirection: 'row'
    },
    thumbsUp: {
        marginLeft: size.B
    }
}));
//# sourceMappingURL=Suggestion.js.map